export default function selectSelectedCustomisationId(state) {
  return state.app.selectedCustomisationId;
}
